"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBasketPageType = void 0;
var isBasketPageType = exports.isBasketPageType = function isBasketPageType() {
  var _jlData$page;
  var jlData = window.jlData || {};
  return ((_jlData$page = jlData.page) === null || _jlData$page === void 0 || (_jlData$page = _jlData$page.pageInfo) === null || _jlData$page === void 0 ? void 0 : _jlData$page.pageType) === 'shopping basket';
};